export interface AppConfig {
  authority: string;
  clientId: string;
  xtmGoProjectId: string;
  /**
   * Risk Assessment app, rendered from RISK_ASSESSMENT_URL at container start.
   * Optional: the env var is optional, so an older or partially-rolled-out
   * config.json may not have it. Absent, not just empty — code reading this
   * field directly (not through buildToolLinks) must handle `undefined`.
   */
  riskAssessmentUrl?: string;
  /** XTM Gateway app, rendered from MT_LLM_GATEWAY_URL at container start. Optional — see riskAssessmentUrl. */
  mtLlmGatewayUrl?: string;
}

let config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch(`${import.meta.env.BASE_URL}config.json`);
  if (!res.ok) {
    throw new Error(`Failed to load config.json (status ${res.status})`);
  }
  config = (await res.json()) as AppConfig;
  return config;
}

export function getConfig(): AppConfig {
  if (!config) throw new Error('App config not loaded — call loadConfig() first');
  return config;
}

/**
 * Non-throwing accessor for readers that must tolerate an unloaded config —
 * the dev and mock auth modes render without a hard config requirement, unlike
 * the oidc path where getConfig()'s invariant protects the UserManager.
 */
export function getOptionalConfig(): AppConfig | null {
  return config;
}

/** Test-only: clear the cached config between cases. */
export function __resetConfigForTest(): void {
  config = null;
}
